import { LatLng, LatLngBounds } from "leaflet";
import { useState } from "react";
import { useMapEvents, Rectangle } from "react-leaflet";
import { enforceMinRectangleSize } from "../../utils/shape/enforceMinRectangleSize";
interface RectangleAnnotationProps {
  onDraw: (latLngs: LatLng[]) => void;
}

const RectangleDrawTool = ({ onDraw }: RectangleAnnotationProps) => {
  const [pointOfOrigin, setPointOfOrigin] = useState<LatLng>();
  const [selectionBounds, setSelectionBounds] = useState<LatLngBounds>();

  useMapEvents({
    click(e) {
      if (selectionBounds) {
        const positions = [
          new LatLng(selectionBounds.getNorthWest().lat, selectionBounds.getNorthWest().lng),
          new LatLng(selectionBounds.getSouthWest().lat, selectionBounds.getSouthWest().lng),
          new LatLng(selectionBounds.getSouthEast().lat, selectionBounds.getSouthEast().lng),
          new LatLng(selectionBounds.getNorthEast().lat, selectionBounds.getNorthEast().lng),
        ];
        const validatedPositions = enforceMinRectangleSize(positions);
        onDraw(validatedPositions);
        setPointOfOrigin(undefined);
        setSelectionBounds(undefined);
        return;
      }
      setPointOfOrigin(e.latlng);
    },
    mousemove(e) {
      if (pointOfOrigin) setSelectionBounds(new LatLngBounds(pointOfOrigin, e.latlng));
    },
  });

  return selectionBounds ? <Rectangle bounds={selectionBounds} /> : null;
};

export default RectangleDrawTool;
